import styled from 'styled-components';

import { Flex } from '@/components/base';
import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import useKeymap from '@/hooks/pure/useKeymap';

import { useModalContext } from '../../../components/Modal/Modal';
import Navigator from './Navigator';

const NavigatorFloat = () => {
  const wr = useWorkspaceRouter();
  const { closeModal } = useModalContext();

  useKeymap('Escape', closeModal);

  return (
    <Style>
      <Flex className="float-wrapper">
        <div
          style={{
            width: '100%',
          }}
        >
          <Navigator
            onSubmitCallback={async (item) => {
              await closeModal();
              wr.push(item.href);
            }}
          />
        </div>
      </Flex>
    </Style>
  );
};

const Style = styled.div`
  width: 760px;
  height: 500px;
  position: relative;
  .float-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
`;

export default NavigatorFloat;
